import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ProfileEmptyTabPlaceholderProps {
  /**
   * Placeholder label text rendered inside the centered paragraph. Defaults
   * to `"Coming soon"` (the canonical empty-tab copy at
   * jobs/pipeline/profile and search/profile).
   */
  children?: ReactNode;
  /** Optional className override applied to the outer wrapper. */
  className?: string;
}

/**
 * Centered "Coming soon" placeholder rendered when a tab has no implemented
 * body yet (jobs/pipeline/profile and search/profile). Applies the canonical
 * `"flex items-center justify-center px-8 py-16"` wrapper and renders the
 * label inside a `"text-sm font-normal text-foreground/40"` paragraph.
 */
export function ProfileEmptyTabPlaceholder({
  children = "Coming soon",
  className,
}: ProfileEmptyTabPlaceholderProps) {
  return (
    <div
      className={cn("flex items-center justify-center px-8 py-16", className)}
    >
      <p className="text-sm font-normal text-foreground/40">{children}</p>
    </div>
  );
}
